import React from 'react';
import { Container, Wrench, Zap } from 'lucide-react';
import { openWhatsApp } from '../lib/whatsapp';

const Services = () => {
  const services = [
    {
      icon: Container,
      title: 'Fabricación de Cubas para Transformadores',
      description: 'Diseño y fabricación de cubas de alta calidad para transformadores eléctricos, incluyendo paneles aletados refrigerantes, cumpliendo con los más exigentes estándares de la industria.',
      image: '/images/service-cubas-transformadores.jpg',
      features: [
        'Diseño a medida',
        'Paneles aletados refrigerantes',
        'Materiales de primera calidad',
        'Control de calidad riguroso',
        'Cumplimiento normativas técnicas'
      ]
    },
    {
      icon: Wrench,
      title: 'Montajes Industriales y Estructuras Metálicas',
      description: 'Servicios integrales de construcción de galpones metálicos, estructuras metálicas y montajes industriales con precisión y eficiencia.',
      image: '/images/service-estructuras-metalicas.jpg',
      features: [
        'Galpones metálicos industriales',
        'Construcción de estructuras metálicas',
        'Montaje de equipamiento',
        'Supervisión técnica',
        'Plazos de entrega garantizados'
      ]
    }
  ];

  return (
    <section id="servicios" className="py-20 bg-gray-50">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-brand mb-4">
            Servicios Metalmecánicos Especializados en Mendoza
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Soluciones integrales en metalmecánica industrial: fabricación de cubas para transformadores con paneles aletados refrigerantes, construcción de galpones metálicos, estructuras metálicas y montajes industriales. Calidad y experiencia garantizada.
          </p>
        </div>

        {/* Services Grid */}
        <div className="space-y-16">
          {services.map((service, index) => {
            const Icon = service.icon;
            const isEven = index % 2 === 0;

            return (
              <div
                key={index}
                className="grid lg:grid-cols-2 gap-8 items-center"
              >
                {/* Content - Always first on mobile, alternates on desktop */}
                <div className={`order-1 ${isEven ? 'lg:order-1' : 'lg:order-2'}`}>
                  <div className="bg-white p-8 rounded-lg shadow-lg">
                    <div className="inline-flex items-center justify-center w-14 h-14 bg-brand rounded-lg mb-6">
                      <Icon className="w-7 h-7 text-white" />
                    </div>
                    <h3 className="text-2xl font-bold text-brand mb-4">
                      {service.title}
                    </h3>
                    <p className="text-gray-600 mb-6 leading-relaxed">
                      {service.description}
                    </p>
                    <ul className="space-y-3">
                      {service.features.map((feature, idx) => (
                        <li key={idx} className="flex items-start">
                          <svg
                            className="w-5 h-5 text-brand mr-3 mt-0.5 flex-shrink-0"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path
                              fillRule="evenodd"
                              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                              clipRule="evenodd"
                            />
                          </svg>
                          <span className="text-gray-700">{feature}</span>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>

                {/* Image - Always second on mobile, alternates on desktop */}
                <div className={`order-2 ${isEven ? 'lg:order-2' : 'lg:order-1'}`}>
                  <div className="relative h-[350px] sm:h-[400px] rounded-lg overflow-hidden shadow-xl">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover object-center hover:scale-105 transition-transform duration-500"
                    />
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        {/* CTA */}
        <div className="mt-16 text-center">
          <p className="text-lg text-gray-700 mb-6">
            ¿Necesita un presupuesto personalizado?
          </p>
          <button
            onClick={() => openWhatsApp('Hola, me gustaría solicitar un presupuesto.')}
            className="inline-flex items-center px-8 py-4 bg-brand text-white font-semibold rounded-md hover:bg-brand-dark transition-all duration-300"
          >
            Solicitar Presupuesto
          </button>
        </div>
      </div>
    </section>
  );
};

export default Services;
